import { render, staticRenderFns } from "./BotaoTooltip.vue?vue&type=template&id=929500ec&scoped=true"
import script from "./BotaoTooltip.vue?vue&type=script&lang=js"
export * from "./BotaoTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "929500ec",
  null
  
)

export default component.exports